module.exports = __webpack_public_path__ + "img/cashier04.5e035688.png";